import {
  MenuItem,
  TextField,
  Typography,
  Grid,
  Stack,
  Divider,
  Button,
  Drawer,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
  AlertTitle,
  Snackbar,
  Skeleton,
} from '@mui/material'
import { DatePicker, Expandable } from '../helper'
import './RmaEmails.css'
import dayjs from 'dayjs'
import { rmaDetailType } from './RmaDetails'
import { useContext, useState } from 'react'
import { ArrowForward } from '@mui/icons-material'
import { rmaLineType, salesOrderLineType } from '../types'
import { rmaMerchandizeConditions } from '../lists'
import axios from 'axios'
import { dataContext } from '..'

export function RmaEmailToVendor(props: {
  rma: rmaDetailType
  rmaLines: (rmaLineType & salesOrderLineType)[]
  edit: boolean
  userType: string
  setRma: React.Dispatch<React.SetStateAction<rmaDetailType>>
  loading?: boolean
}) {
  const [openEmailDrawer, setOpenEmailDrawer] = useState(false)

  return (
    <div>
      <Grid container spacing="56px" className="rma-emails-grid">
        <Grid size={6}>
          <Stack spacing="16px">
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={200} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Vendor Action Request Email Date:</Typography>
                  <DatePicker
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    value={dayjs.utc(props.rma.rma_vendor_action_request_email_date)}
                    disabled={!props.edit}
                    onChange={date => {
                      props.setRma({ ...props.rma, rma_vendor_action_request_email_date: date?.toDate() ?? null })
                    }}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={180} />
                  <Skeleton variant="rounded" width="100%" height={400} />
                </>
              ) : (
                <>
                  <Typography variant="body2">RMA Vendor Action Request:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    multiline
                    rows={26.8}
                    fullWidth
                    value={props.rma.rma_vendor_action_request}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, rma_vendor_action_request: e.target.value })}
                  />
                </>
              )}
            </div>
          </Stack>
        </Grid>
        <Grid size={6}>
          <Stack spacing="24px">
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={150} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">RMA Vendor Action Result:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    select
                    fullWidth
                    size="small"
                    label="Select Status"
                    value={props.rma.rma_vendor_action_request_result ?? null}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, rma_vendor_action_request_result: e.target.value })}
                  >
                    <MenuItem key={'A'} value={'A'}>
                      Approved
                    </MenuItem>
                    <MenuItem key={'D'} value={'D'}>
                      Denied
                    </MenuItem>
                  </TextField>
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={120} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Vendor RMA Number:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    label="Vendor RMA Number"
                    value={props.rma.vendor_rma_number}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, vendor_rma_number: e.target.value })}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={100} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">RMA Expiration:</Typography>
                  <DatePicker
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    label="RMA Expiration"
                    value={props.rma.rma_expiration_date ? dayjs.utc(props.rma.rma_expiration_date) : null}
                    disabled={!props.edit}
                    onChange={date => {
                      props.setRma({ ...props.rma, rma_expiration_date: date?.toDate() ?? null })
                    }}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={120} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Vendor POC Name:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    label="Vendor POC Name"
                    value={props.rma.vendor_poc_name}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, vendor_poc_name: e.target.value })}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={110} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Vendor POC Tel:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    label="Vendor POC Tel"
                    value={props.rma.vendor_poc_phone}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, vendor_poc_phone: e.target.value })}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={100} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Restocking Fee:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    label="Select"
                    select
                    value={props.rma.restocking_fee === null ? '' : props.rma.restocking_fee ? 'Y' : 'N'}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, restocking_fee: e.target.value === 'Y' })}
                  >
                    <MenuItem key={'Y'} value={'Y'}>
                      Yes
                    </MenuItem>
                    <MenuItem key={'N'} value={'N'}>
                      No
                    </MenuItem>
                  </TextField>
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={200} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Vendor Action Result Receive Date:</Typography>
                  <DatePicker
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    label="Vendor Action Result Receive Date"
                    value={
                      props.rma.rma_vendor_action_request_result_receive_date
                        ? dayjs.utc(props.rma.rma_vendor_action_request_result_receive_date)
                        : null
                    }
                    disabled={!props.edit}
                    onChange={date => {
                      props.setRma({
                        ...props.rma,
                        rma_vendor_action_request_result_receive_date: date?.toDate() ?? null,
                      })
                    }}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={130} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Vendor POC Email:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    label="Vendor POC Email"
                    value={props.rma.vendor_poc_email}
                    disabled={!props.edit}
                    onChange={e => props.setRma({ ...props.rma, vendor_poc_email: e.target.value })}
                  />
                </>
              )}
            </div>
          </Stack>
        </Grid>
      </Grid>
      {props.userType !== 'Office Staff' && props.userType !== 'Sales Rep' && (
        <>
          <Divider />
          <div className="rma-emails-send-button-container">
            {props.loading ? (
              <Skeleton width={200} height={36} />
            ) : (
              <Button variant="contained" onClick={() => setOpenEmailDrawer(true)} disabled={props.edit}>
                Create Email to Vendor
              </Button>
            )}
          </div>
        </>
      )}
      <Drawer anchor="right" open={openEmailDrawer} onClose={() => setOpenEmailDrawer(false)}>
        <RmaEmailSidePanel
          title="Create RMA E-mail to Vendor"
          rma={props.rma}
          rmaLines={props.rmaLines}
          setOpenEmailDrawer={setOpenEmailDrawer}
          setRma={props.setRma}
          email={{
            to: '',
            cc: process.env.REACT_APP_OPS_EMAIL ?? '',
            subject: `RMA request from IMPRES, P.O. #${props.rma.vendor_number}, End User P.O. #${props.rma.government_award_number}`,
            body: props.rma.rma_vendor_action_request ?? '',
          }}
          info={[
            {
              label: 'Case Number',
              data: props.rma.rma_number,
            },
            {
              label: 'Customer Reason',
              data: props.rma.rma_customer_reason ?? '',
            },
            {
              label: 'Merchandise Condition',
              data:
                rmaMerchandizeConditions.find(condition => condition.id === props.rma.rma_merchandize_condition_id)
                  ?.label ?? '',
            },
            {
              label: 'Pickup Address',
              data: props.rma.pickup_address ?? '',
            },
            {
              label: 'Pickup Contact Name',
              data: props.rma.pickup_contact ?? '',
            },
            {
              label: 'Pickup Contact Phone',
              data: props.rma.pickup_phone_number ?? '',
            },
            {
              label: 'Pickup Contact Email',
              data: props.rma.pickup_email_id ?? '',
            },
          ]}
        />
      </Drawer>
    </div>
  )
}

export function RmaInternalEscalationEmail(props: {
  rma: rmaDetailType
  rmaLines: (rmaLineType & salesOrderLineType)[]
  edit: boolean
  userType: string
  setRma: React.Dispatch<React.SetStateAction<rmaDetailType>>
  loading?: boolean
}) {
  const { operations, user } = useContext(dataContext)
  const [openEmailDrawer, setOpenEmailDrawer] = useState(false)

  return (
    <div>
      <Grid container spacing="56px" className="rma-emails-grid">
        <Grid size={6}>
          <div className="rma-emails-grid-item">
            {props.loading ? (
              <>
                <Skeleton width={180} />
                <Skeleton variant="rounded" width="100%" height={200} />
              </>
            ) : (
              <>
                <Typography variant="body2">RMA Escalation Action Result:</Typography>
                <TextField
                  className="rma-emails-grid-item-textfield"
                  size="small"
                  fullWidth
                  multiline
                  rows={9.7}
                  disabled={!props.edit}
                  value={props.rma.rma_escalation_action_result}
                  onChange={e => props.setRma({ ...props.rma, rma_escalation_action_result: e.target.value })}
                />
              </>
            )}
          </div>
        </Grid>
        <Grid size={6}>
          <Stack spacing="24px">
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={180} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">RMA Escalation Action User:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    select
                    disabled={!props.edit}
                    value={props.rma.rma_escalation_action_user_id}
                    onChange={e => props.setRma({ ...props.rma, rma_escalation_action_user_id: e.target.value })}
                  >
                    {operations.map(user => (
                      <MenuItem key={user.user_id} value={user.user_id}>
                        {user.display_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={140} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">RMA Escalation Date:</Typography>
                  <DatePicker
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    disabled={!props.edit}
                    value={props.rma.rma_escalation_date ? dayjs.utc(props.rma.rma_escalation_date) : null}
                    onChange={date => props.setRma({ ...props.rma, rma_escalation_date: date?.toDate() ?? null })}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={180} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Escalation Action Result Date:</Typography>
                  <DatePicker
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    disabled={!props.edit}
                    value={
                      props.rma.rma_escalation_action_result_date
                        ? dayjs.utc(props.rma.rma_escalation_action_result_date)
                        : null
                    }
                    onChange={date =>
                      props.setRma({ ...props.rma, rma_escalation_action_result_date: date?.toDate() ?? null })
                    }
                  />
                </>
              )}
            </div>
          </Stack>
        </Grid>
      </Grid>
      {props.userType !== 'Office Staff' && props.userType !== 'Sales Rep' && (
        <>
          <Divider />
          <div className="rma-emails-send-button-container">
            {props.loading ? (
              <Skeleton width={250} height={36} />
            ) : (
              <Button variant="contained" onClick={() => setOpenEmailDrawer(true)} disabled={props.edit}>
                Create Internal Escalation Email
              </Button>
            )}
          </div>
        </>
      )}
      <Drawer anchor="right" open={openEmailDrawer} onClose={() => setOpenEmailDrawer(false)}>
        <RmaEmailSidePanel
          title="Create RMA Escalation E-mail"
          rma={props.rma}
          rmaLines={props.rmaLines}
          setOpenEmailDrawer={setOpenEmailDrawer}
          setRma={props.setRma}
          email={{
            to: user.email,
            cc: process.env.REACT_APP_OPS_EMAIL ?? '',
            subject: `Escalation for our Sales Order Number: ${props.rma.so_number}`,
            body: '',
          }}
          info={[
            {
              label: 'Case Number',
              data: props.rma.rma_number,
            },
            {
              label: 'Customer Reason',
              data: props.rma.rma_customer_reason ?? '',
            },
            {
              label: 'Merchandise Condition',
              data:
                rmaMerchandizeConditions.find(condition => condition.id === props.rma.rma_merchandize_condition_id)
                  ?.label ?? '',
            },
          ]}
        />
      </Drawer>
    </div>
  )
}

export function RmaEmailToCustomer(props: {
  rma: rmaDetailType
  rmaLines: (rmaLineType & salesOrderLineType)[]
  edit: boolean
  userType: string
  setRma: React.Dispatch<React.SetStateAction<rmaDetailType>>
  loading?: boolean
}) {
  const [openEmailDrawer, setOpenEmailDrawer] = useState(false)

  return (
    <div>
      <Grid container spacing="56px" className="rma-emails-grid">
        <Grid size={6}>
          <div className="rma-emails-grid-item">
            {props.loading ? (
              <>
                <Skeleton width={180} />
                <Skeleton variant="rounded" width="100%" height={200} />
              </>
            ) : (
              <>
                <Typography variant="body2">Notes for Customer Reference:</Typography>
                <TextField
                  className="rma-emails-grid-item-textfield"
                  size="small"
                  fullWidth
                  multiline
                  rows={9.7}
                  disabled={!props.edit}
                  value={props.rma.customer_instruction}
                  onChange={e => props.setRma({ ...props.rma, customer_instruction: e.target.value })}
                />
              </>
            )}
          </div>
        </Grid>
        <Grid size={6}>
          <Stack spacing="24px">
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={150} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </>
              ) : (
                <>
                  <Typography variant="body2">RMA Customer Email Date:</Typography>
                  <DatePicker
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    disabled
                    value={props.rma.rma_customer_email_date ? dayjs.utc(props.rma.rma_customer_email_date) : null}
                    onChange={date => props.setRma({ ...props.rma, rma_customer_email_date: date?.toDate() ?? null })}
                  />
                </>
              )}
            </div>
            <div className="rma-emails-grid-item">
              {props.loading ? (
                <>
                  <Skeleton width={200} />
                  <Skeleton variant="rounded" width="100%" height={120} />
                </>
              ) : (
                <>
                  <Typography variant="body2">Tracking Details Vendor to Customer:</Typography>
                  <TextField
                    className="rma-emails-grid-item-textfield"
                    size="small"
                    fullWidth
                    multiline
                    rows={5.3}
                    disabled={!props.edit}
                    value={props.rma.tracking_details_vendor_to_customer}
                    onChange={e => props.setRma({ ...props.rma, tracking_details_vendor_to_customer: e.target.value })}
                  />
                </>
              )}
            </div>
          </Stack>
        </Grid>
      </Grid>
      {props.userType !== 'Office Staff' && props.userType !== 'Sales Rep' && (
        <>
          <Divider />
          <div className="rma-emails-send-button-container">
            {props.loading ? (
              <Skeleton width={200} height={36} />
            ) : (
              <Button variant="contained" onClick={() => setOpenEmailDrawer(true)} disabled={props.edit}>
                Create Email to Customer
              </Button>
            )}
          </div>
        </>
      )}
      <Drawer anchor="right" open={openEmailDrawer} onClose={() => setOpenEmailDrawer(false)}>
        <RmaEmailSidePanel
          title="Create RMA E-mail to Customer"
          rma={props.rma}
          rmaLines={props.rmaLines}
          setOpenEmailDrawer={setOpenEmailDrawer}
          setRma={props.setRma}
          email={{
            to: '',
            cc: process.env.REACT_APP_OPS_EMAIL ?? '',
            subject: `RMA Resolved for your Contract Number/Purchase Order: ${props.rma.government_award_number}`,
            body: props.rma.customer_instruction ?? '',
          }}
          info={[
            {
              label: 'RMA Vendor Action Result',
              data:
                props.rma.rma_vendor_action_request_result === 'A'
                  ? 'Approved'
                  : props.rma.rma_vendor_action_request_result === 'D'
                  ? 'Denied'
                  : '-',
            },
            {
              label: 'Vendor RMA Number',
              data: props.rma.vendor_rma_number ?? '-',
            },
            {
              label: 'Expiration Date',
              data: props.rma.rma_expiration_date ? dayjs(props.rma.rma_expiration_date).format('MM/DD/YYYY') : '-',
            },
            {
              label: 'Tracking Details',
              data: props.rma.tracking_details_vendor_to_customer ?? '-',
            },
            {
              label: 'Pickup Address',
              data: props.rma.pickup_address ?? '-',
            },
            {
              label: 'Pickup Contact Name',
              data: props.rma.pickup_contact ?? '-',
            },
            {
              label: 'Pickup Contact Phone',
              data: props.rma.pickup_phone_number ?? '-',
            },
            {
              label: 'Pickup Contact Email',
              data: props.rma.pickup_email_id ?? '-',
            },
          ]}
        />
      </Drawer>
    </div>
  )
}

function RmaEmailSidePanel(props: {
  rma: rmaDetailType
  rmaLines: (rmaLineType & salesOrderLineType)[]
  title: string
  email: {
    to: string
    cc: string
    subject: string
    body: string
  }
  info: {
    label: string
    data: string
  }[]
  setOpenEmailDrawer: (open: boolean) => void
  setRma: React.Dispatch<React.SetStateAction<rmaDetailType>>
}) {
  const { user } = useContext(dataContext)
  const [email, setEmail] = useState(props.email)
  const [emailStatus, setEmailStatus] = useState('')

  const handleSendEmail = (customerEmail: boolean) => {
    setEmailStatus('')
    axios
      .post('/sendEmail', {
        to: email.to.split(';'),
        cc: email.cc ? email.cc.split(';') : [],
        subject: email.subject,
        body:
          email.body.replaceAll('\n', '<br/>') +
          `
      <br /><br />
      ${props.info.map(info => `<b>${info.label}:</b> ${info.data}<br /><br />`).join('')}
      
      <table style="border: 1px solid black; border-collapse: collapse;">
        <tr>
          <td style="border: 1px solid black; text-align: center;"><b>ITEM PART NO.</b></td>
          <td style="border: 1px solid black; text-align: center;"><b>ITEM DESCRIPTION</b></td>
          <td style="border: 1px solid black; text-align: center;"><b>RMA QUANTITY</b></td>
          <td style="border: 1px solid black; text-align: center;"><b>SERIAL NUMBER</b></td>
          <td style="border: 1px solid black; text-align: center;"><b>COMMENTS</b></td>
        </tr>
        ${props.rmaLines
          .map(
            line => `
        <tr>
          <td style="border: 1px solid black; vertical-align: text-top">${line.item_name}</td>
          <td style="border: 1px solid black; vertical-align: text-top">${line.item_desc}</td>
          <td style="border: 1px solid black; vertical-align: text-top">${line.rma_quantity}</td>
          <td style="border: 1px solid black; vertical-align: text-top">${line.serial_number}</td>
          <td style="border: 1px solid black; vertical-align: text-top">${line.rma_comment}</td>
        </tr>
        `,
          )
          .join('')}
      </table>
      `,
      })
      .then(() => {
        setEmailStatus('sent')
        if (customerEmail) {
          axios
            .post(`/rma/${props.rma.rma_id}/edit`, {
              rma: {
                rma_customer_email_date: new Date(),
              },
              user: user.user_id,
            })
            .then(() => {
              props.setRma((prev: rmaDetailType) => ({ ...prev, rma_customer_email_date: new Date() }))
            })
        }
      })
      .catch(error => {
        console.error(error)
        setEmailStatus('error')
      })
  }

  return (
    <div className="rma-emails-sidepanel-container">
      <div className="rma-emails-sidepanel-header">
        <Typography variant="h6">{props.title}</Typography>
        <IconButton onClick={() => props.setOpenEmailDrawer(false)}>
          <ArrowForward />
        </IconButton>
      </div>
      <Divider />
      <div className="rma-emails-sidepanel-body">
        <div className="rma-emails-sidepanel-email-form">
          <div className="rma-emails-sidepanel-email-form-item">
            <Typography variant="body2">To:</Typography>
            <TextField
              size="small"
              label="To"
              value={email.to}
              onChange={e => setEmail({ ...email, to: e.target.value })}
            />
          </div>
          <div className="rma-emails-sidepanel-email-form-item">
            <Typography variant="body2">CC:</Typography>
            <TextField
              size="small"
              label="CC"
              value={email.cc}
              onChange={e => setEmail({ ...email, cc: e.target.value })}
            />
          </div>
          <div className="rma-emails-sidepanel-email-form-item">
            <Typography variant="body2">Subject:</Typography>
            <TextField
              size="small"
              label="Subject"
              value={email.subject}
              onChange={e => setEmail({ ...email, subject: e.target.value })}
            />
          </div>
          <div className="rma-emails-sidepanel-email-form-body">
            <Typography variant="body2">E-mail Body:</Typography>
            <TextField
              size="small"
              label="E-mail Body"
              multiline
              rows={7}
              value={email.body}
              onChange={e => setEmail({ ...email, body: e.target.value })}
            />
          </div>
          <Button
            variant="contained"
            disabled={!email.to || !email.subject || !email.body}
            onClick={() => handleSendEmail(props.title === 'Create RMA E-mail to Customer')}
          >
            Send E-mail
          </Button>
          {emailStatus === 'error' && (
            <Alert severity="error">
              <AlertTitle>Email Delivery Failed</AlertTitle>
              Please try again. If the problem persists, please contact support.
            </Alert>
          )}
        </div>
        <div className="rma-emails-sidepanel-order-info">
          <div className="rma-emails-sidepanel-order-header-info">
            {props.info.map(info => (
              <div className="rma-emails-sidepanel-order-header-info-item">
                <Typography variant="body2" color="text.secondary">
                  {info.label}:
                </Typography>
                <Typography>{info.data}</Typography>
              </div>
            ))}
          </div>
          <TableContainer className="rma-emails-sidepanel-lines-table">
            <Table>
              <TableHead className="rma-emails-sidepanel-lines-table-header">
                <TableRow>
                  <TableCell>Item Description</TableCell>
                  <TableCell>Item SKU</TableCell>
                  <TableCell align="right">RMA Qty</TableCell>
                  <TableCell align="right">Serial No.</TableCell>
                  <TableCell>Comments</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.rmaLines.map(line => (
                  <TableRow>
                    <TableCell>
                      <Expandable text={line.item_desc} />
                    </TableCell>
                    <TableCell>{line.item_name}</TableCell>
                    <TableCell align="right">{line.rma_quantity}</TableCell>
                    <TableCell align="right">{line.serial_number}</TableCell>
                    <TableCell>{line.rma_comment}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <Snackbar
        open={emailStatus === 'sent'}
        autoHideDuration={6000}
        onClose={() => setEmailStatus('')}
        message="Email Sent"
      />
    </div>
  )
}
